import { Theme, Components, darken } from '@mui/material/styles';
import CloseIcon from '@mui/icons-material/Close';

export const MuiChip: Components<Theme>['MuiChip'] = {
  defaultProps: {
    deleteIcon: <CloseIcon sx={{ width: '20px', height: '20px' }} />,
    size: 'medium',
  },
  styleOverrides: {
    root: ({ theme, ownerState }) => {
      const color = ownerState.color ?? 'default';

      const colorStyles: Record<
        string,
        { backgroundColor: string; color: string; border?: string }
      > = {
        default: {
          backgroundColor: theme.palette.customColors.pageBg,
          color: theme.palette.customColors.chipDefaultText,
        },
        primary: {
          backgroundColor: theme.palette.customColors.pageBg,
          color: theme.palette.customColors.chipDefaultText,
        },
        secondary: {
          backgroundColor: theme.palette.customColors.chipSecondaryBg,
          color: theme.palette.warning.main,
        },
        warning: {
          backgroundColor: theme.palette.customColors.chipSecondaryBg,
          color: theme.palette.warning.main,
        },
        error: {
          backgroundColor: theme.palette.customColors.errorBg,
          color: theme.palette.error.main,
        },
        success: {
          backgroundColor: theme.palette.customColors.successBg,
          color: theme.palette.success.main,
        },
      };

      const styles = colorStyles[color] ?? colorStyles['default'];

      return {
        border: 'none',
        maxWidth: '350px',
        ...theme.typography.body2,
        ...styles,
        // Clickable chips: subtly darken the chip's OWN background instead of
        // MUI's default jump to palette[color].dark (which is far too dark).
        '&.MuiChip-clickable': {
          '&:hover, &:focus, &.Mui-focusVisible': {
            backgroundColor: darken(styles.backgroundColor, 0.06),
          },
        },
      };
    },
  },
  variants: [
    {
      props: { size: 'small' },
      style: {
        height: '24px',
        borderRadius: '4px',
      },
    },
    {
      props: { size: 'medium' },
      style: {
        height: '30px',
        borderRadius: '4px',
      },
    },
  ],
};
